import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const factoreldConfig: TSPConfig = {
  key: 'factoreld',
  name: 'FactorELD',
  imageName: 'FactorELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please provide your FactorELD credentials.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'API Key',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default factoreldConfig;
